var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.5,
    height: 7.5,
    x: 2.75,
    y: 2.751,
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.25,
    cy: 6.501,
    r: 1.25,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.25,
    cy: 6.501,
    r: 1.25,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.5,
    height: 7.5,
    x: 2.75,
    y: 13.749,
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.25,
    cy: 17.499,
    r: 1.25,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.25,
    cy: 17.499,
    r: 1.25,
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer);
export default __webpack_public_path__ + "static/media/server.b585bbd938bc097fbb2a930b8896b899.svg";
export { ForwardRef as ReactComponent };